module.exports = __webpack_public_path__ + "static/media/vericel-nxb-invite.83ef4205.png";